<template>
  <div>
    <v-menu :close-on-content-click="false" v-model="add">
      <template #activator="{ on }">
        <a v-on="on">Add a location...</a>
      </template>

      <v-card min-width="400">
        <v-card-title class="mb-0 pb-0">Add a Location</v-card-title>
        <v-card-text class="mb-0 pb-0">
          <v-row dense>
            <v-col cols="6">
              <v-list dense>
                <v-subheader>Select a Site</v-subheader>
                <v-list-item-group v-model="siteId" class="selection-list">
                  <v-list-item v-for="s in sitesById" :key="s.id" :value="s.id">
                    <template #default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title v-text="s.title"/>
                      </v-list-item-content>

                      <v-list-item-action class="ma-0">
                        <v-checkbox :input-value="active" color="primary"/>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
            <v-col cols="6">
              <v-list dense>
                <v-subheader v-if="siteId">Select a Room</v-subheader>
                <div v-if="!loaded" class="loading">
                  <v-progress-circular indeterminate color="accent"/>
                </div>
                <v-list-item-group
                    v-else
                    v-model="selectedResources"
                    class="selection-list"
                    multiple>
                  <v-list-item
                      v-for="r in filteredResources"
                      :key="r.id"
                      :value="r">
                    <template #default="{ active }">
                      <v-list-item-content>
                        <v-list-item-title v-text="r.title"/>
                      </v-list-item-content>

                      <v-list-item-action class="ma-0">
                        <v-checkbox :input-value="active" color="primary"/>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                  <v-subheader v-if="siteId && filteredResources.length === 0">
                    No available rooms
                  </v-subheader>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              @click="confirm"
              color="accent"
              :disabled="selectedResources.length === 0"
              depressed>
            Confirm
          </v-btn>
          <v-btn text @click="reset">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex';
import {byRef} from '@/store/firestore-util';

export default {
  name: 'AddReservation',
  props: {
    event: {
      type: Object,
      default: null
    },
    resourceRefs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      add: false,
      siteId: null,
      selectedResources: []
    };
  },
  computed: {
    ...mapGetters('sites', ['sitesById']),
    ...mapGetters('views/roomBooking/booking/siteResources', ['loaded']),
    ...mapState('views/roomBooking/booking/siteResources', ['resources']),
    filteredResources() {
      return this.resources.filter(r => !this.resourceRefs.includes(byRef(r)));
    }
  },
  watch: {
    siteId: {
      immediate: true,
      handler(siteId) {
        this.setSelectedSite(siteId);
      }
    }
  },
  methods: {
    ...mapMutations('views/roomBooking/booking/siteResources', ['setSelectedSite']),
    confirm() {
      for (const resource of this.selectedResources) {
        this.event.addReservation(resource);
      }
      this.reset();
    },
    reset() {
      this.siteId = null;
      this.selectedResources = [];
      this.add = false;
    }
  }
};
</script>

<style scoped>
.loading {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.selection-list {
  --list-item-height: 40px;
  max-height: calc(5 * var(--list-item-height));
  overflow: auto;
}
</style>
